import cx from "classnames";
import { memo } from "react";
import { MinusIcon, PlusIcon } from "@/icons";
import styles from "../FullscreenPresentationLayout.module.scss";
import type { ZoomDirection } from "../types";

type ZoomControlProps = {
    zoom: number;
    onChangeZoom: (direction: ZoomDirection) => void;
};

export const ZoomControl = memo(({ zoom, onChangeZoom }: ZoomControlProps) => {
    const handleClickZoomOut = () => {
        onChangeZoom("out");
    };
    const handleClickZoomIn = () => {
        onChangeZoom("in");
    };
    return (
        <div className={styles.zoomControl}>
            <button
                className={cx(styles.navigationButton, styles.minus)}
                type="button"
                onClick={handleClickZoomOut}
            >
                <MinusIcon />
            </button>

            <div className={styles.zoom}>{zoom}%</div>

            <button className={styles.navigationButton} type="button" onClick={handleClickZoomIn}>
                <PlusIcon />
            </button>
        </div>
    );
});
